var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-control",class:{
    'has-icon': _vm.icon,
    'focused': _vm.isFocused,
    'disabled': _vm.disabled,
    'has-error': _vm.error
  }},[_c('date-picker',_vm._b({attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"config":_vm.computedOptions},on:{"dp-show":_vm.onOpen,"dp-hide":_vm.onClose,"dp-change":_vm.onInput},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'date-picker',_vm.$attrs,false)),(_vm.icon)?_c('div',{staticClass:"icon"},[_vm._t("icon")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }